import * as React from "react";
import Header from "./header";
import Footer from "./footer";

const Layout = ({ currentPath, children, fullScreen=false }) => {
  return (
    <div className={`flex flex-col ${fullScreen ? "min-h-screen": "min-h-full"}`}>
      <header className="mx-auto w-full max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
        <Header currentPath={currentPath} />
      </header>
      <main className="min-h-full">
        <div className="mx-auto max-w-7xl py-6 sm:px-6 lg:px-8">
          {children}
        </div>
      </main>
      <div className={`w-full${fullScreen ? "": " fixed bottom-0"}`}>
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
